module.exports = __webpack_public_path__ + "static/sixstories-247228d6359f1184eaec769aada0df8b.jpg";